import React from "react";
import { TextField, TextFieldProps, InputAdornment } from "@mui/material";

type DynamicTextFieldProps = {
  label?: string;
  variant?: "outlined" | "filled" | "standard";
  type?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string | React.ReactNode;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
  placeholder?: string;
  name?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  size?: "small" | "medium";
  color?: "primary" | "secondary" | "success";
  accept?: string; 
  multiple?: boolean; 
} & TextFieldProps;

const DynamicTextField: React.FC<DynamicTextFieldProps> = ({
  label,
  variant = "outlined",
  type = "text",
  value,
  onChange,
  error = false,
  helperText = "",
  fullWidth = false,
  required = false,
  disabled = false,
  multiline = false,
  rows,
  placeholder,
  name,
  startIcon,
  endIcon,
  size = "medium",
  color = "primary",
  accept,
  multiple = false,
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "file") {
      if (onChange) onChange(e); 
    } else {
      const trimmedValue = e.target.value.trimStart();
      if (onChange) {
        e.target.value = trimmedValue;
        onChange(e);
      }
    }
  };

  return (
    <TextField
      label={label}
      variant={variant}
      type={type}
      value={type === "file" ? undefined : value} 
      onChange={handleChange}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
      multiline={type === "file" ? false : multiline} 
      rows={rows}
      placeholder={type === "file" ? undefined : placeholder} 
      name={name}
      size={size}
      color={color}
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : null,
        endAdornment: endIcon ? (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ) : null,
        inputProps: {
          accept: type === "file" ? accept : undefined,
          multiple: type === "file" ? multiple : undefined,
        },
      }}
      {...rest}
    />
  );
};

export default DynamicTextField;
